import { useEffect } from 'react';

import { FilterAction } from '@/types/SearchFacet';
import { modifyParamsRemovePage } from '@/utils/queryParams';

import { useNavigateSearchPageWithParams } from './useNavigateSearchPageWithParams';

type Props = {
    isInitialLoading: boolean;
    isLoadingSearchResults: boolean;
    page: number;
    queryParams: any;
    totalPages: number;
};

/**
 * Redirects to page 1 when the requested page number exceeds the total available pages.
 * This prevents users from seeing an empty state when navigating to invalid page numbers.
 */

export const useRedirectToValidPage = ({
    isInitialLoading,
    isLoadingSearchResults,
    page,
    queryParams,
    totalPages,
}: Props) => {
    const navigateSearchPageWithParams = useNavigateSearchPageWithParams();

    useEffect(() => {
        if (!isLoadingSearchResults && !isInitialLoading && totalPages > 0 && page > totalPages) {
            // This removes the page param from the URL, which causes queryParams.page to be undefined, which then defaults to 1.
            const newParams = modifyParamsRemovePage(queryParams);
            navigateSearchPageWithParams({ filterAction: FilterAction.PageChanged, params: newParams });
        }
    }, [isLoadingSearchResults, isInitialLoading, totalPages, page, queryParams, navigateSearchPageWithParams]);
};
